import { useRef } from 'react';

const SECRET_CLICK_THRESHOLD_COUNT = 10; // Number of clicks required to trigger the feature flag entry visibility
const SECRET_CLICK_TIMEOUT_IN_MS = 3000; // 3 seconds

interface UseHandleSecretClickProps {
  onSecretClickFulfilled: () => void;
}

interface UseHandleSecretClickReturns {
  onSecretClick: () => void;
}

export const useHandleSecretClick = ({
  onSecretClickFulfilled,
}: UseHandleSecretClickProps): UseHandleSecretClickReturns => {
  const clickCountRef = useRef(0);
  const lastClickTimeRef = useRef<number>();

  const onSecretClick = (): void => {
    const now = Date.now();

    if (lastClickTimeRef.current && now - lastClickTimeRef.current > SECRET_CLICK_TIMEOUT_IN_MS) {
      clickCountRef.current = 0;
    }

    clickCountRef.current += 1;
    lastClickTimeRef.current = now;

    if (clickCountRef.current >= SECRET_CLICK_THRESHOLD_COUNT) {
      onSecretClickFulfilled();

      clickCountRef.current = 0;
      lastClickTimeRef.current = undefined;
    }
  };

  return {
    onSecretClick,
  };
};
